import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'remarkFormat',
  standalone: false
})
export class RemarkFormatPipe implements PipeTransform {
  transform(value: string, args?: any): any {
    return value.replace(/_/g, ' ');
  }
}
